import { render } from "./g-field-block.vue?vue&type=template&id=038793ee&ts=true"
import script from "./g-field-block.vue?vue&type=script&lang=tsx"
export * from "./g-field-block.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__